import clsx from 'clsx'
import merge from 'lodash/merge'
import React, { forwardRef, PropsWithChildren, ReactNode, useId, useImperativeHandle, useRef } from 'react'

import Close from '@Assets/SVG/Close'

import styles from './AccordionV2.module.scss'

export type HTMLAccordionElement = null | HTMLInputElement & {
  close: () => void
  open: () => void
}
interface AccordionProps {
  backdrop?: boolean
  children: ReactNode
  className?: string
  defaultOpen?: boolean
  id: string
  trigger: ReactNode
}
export const useAccordionActions = () => {
  const ref = useRef<HTMLAccordionElement | null>(null)
  return ref
}

export const AccordionV2 = forwardRef<HTMLAccordionElement, PropsWithChildren<AccordionProps>>(({
  backdrop,
  children,
  className,
  defaultOpen,
  id,
  trigger,
}, ref) => {
  const accordion = useRef<HTMLInputElement | null>(null)
  const extraId = useId()
  useImperativeHandle(ref, () => merge(accordion.current, {
    open: () => {
      if (accordion?.current) {
        accordion.current.checked = true
      }
    },
    close: () => {
      if (accordion?.current) {
        accordion.current.checked = false
      }
    },
  }))
  return (
    <div className={clsx(styles.accordionWrapper, className)}>
      <input
        className={styles.checkbox}
        defaultChecked={defaultOpen}
        id={`${extraId}__${id}`}
        ref={accordion}
        type="checkbox"
      />
      <label className={clsx(styles.trigger)} htmlFor={`${extraId}__${id}`}>
        {trigger}
      </label>
      <div className={clsx(
        styles.content,
      )}
      >
        <div className={styles.borderBottom}>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className={styles.close} htmlFor={`${extraId}__${id}`}>
            <Close />
          </label>
        </div>
        {children}
      </div>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      {backdrop && <label className={styles.backdrop} htmlFor={`${extraId}__${id}`} />}
    </div>
  )
})
